import React from 'react';
import { Slider as MuiSlider, styled } from '@mui/material';
import { useNumericSlider } from './useNumericSlider';

const StyledMuiSlider = styled(MuiSlider)<{ max: number }>(({ theme, max }) => ({
  '.MuiSlider-rail': {
    color: theme.palette.grey[700],
    height: 2,
    opacity: 1,
  },
  '.MuiSlider-mark': {
    height: 12,
    color: theme.palette.grey[700],
    backgroundColor: theme.palette.grey[700],
    opacity: 1,
  },
  '.MuiSlider-markLabel': {
    opacity: 1,
    color: theme.palette.grey[800],
    fontSize: '18px',
    '&[data-index="0"]': {
      transform: 'translateX(0)',
    },
    [`&[data-index='${max}']`]: {
      transform: 'translateX(-100%)',
    },
  },
  '.MuiSlider-valueLabel': {
    backgroundColor: 'transparent',
    color: theme.palette.primary.main,
    fontSize: '18px',
  },
}));

interface NumericSliderProps {
  value: number;
  min: number;
  minLabel?: string;
  max: number;
  maxLabel?: string;
  step: number;
  onValueChange: (newValue: number) => void;
}

export const NumericSlider = ({
  value,
  min,
  minLabel,
  max,
  maxLabel,
  step,
  onValueChange,
}: NumericSliderProps) => {
  const { marks } = useNumericSlider(min, max, step, minLabel, maxLabel);

  return (
    <StyledMuiSlider
      value={value}
      min={min}
      max={max}
      step={step}
      getAriaValueText={(v) => v.toString()}
      valueLabelDisplay="on"
      marks={marks}
      track={false}
      aria-label="numeric slider"
      aria-valuetext={value.toString()}
      onChange={(_, newValue) => onValueChange(newValue as number)}
    />
  );
};
